export default __webpack_public_path__ + "static/media/placeholder-dark.e499f2b5.svg";